<template>
  <el-dialog
    append-to-body
    width="800px"
    :title="`${isChange ? '编辑' : '新增'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="3vh"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="title" label="标题">
        <el-input
          placeholder="请输入标题"
          v-model="form.data.title"
          maxlength="50"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="desc" label="描述">
        <my-editor ref="editor" :editorTxt="this.form.data.desc"></my-editor>
      </el-form-item>
      <el-form-item prop="image" label="照片">
        <el-upload
          :limit="9"
          list-type="picture-card"
          action=""
          :headers="{ token: token }"
          :before-upload="beforeAvatarUpload"
          :http-request="httpRequest"
          :on-change="handleChange"
          :file-list="file"
        >
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i> </span
              ><span
                class="el-upload-list__item-preview"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i> </span
            ></span>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import common from "@/util";
import { getStorage } from "@/storage";
import MyEditor from "@/components/MyEditor.vue";
export default {
  name: "NotifyEdit",
  components: {
    MyEditor,
  },
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          title: "",
          desc: "",
          image: "",
        },
        rules: {
          // content: [{ required: true, message: '请输入', trigger: 'change' }],
          title: [{ required: true, message: "请输入", trigger: "change" }],
        },
      },
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
      file: [],
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.isChange = true;
      this.form.data.title = row.title;
      this.form.data.desc = row.desc;
      this.form.data.id = row.id;
      this.file = row.image
        ? row.image.split(",").map((item) => {
            return {
              name: "",
              url: item,
            };
          })
        : [];
      this.fileList = row.image
        ? row.image.split(",").map((item) => {
            return {
              name: "",
              url: item,
            };
          })
        : [];
    },
    reset(done) {
      this.isChange = false;
      this.form.data.title = "";
      this.form.data.desc = "";
      this.fileList = [];
      this.file = [];
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
        done && done();
      });
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleChange(file, fileList) {
      this.file = fileList;
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file) {
      this.fileList.splice(this.file.indexOf(file), 1);
      this.file.splice(this.file.indexOf(file), 1);
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    httpRequest(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("common/qiniu/uploadFile", { formData, type: "upload" })
        .then((res) => {
          // this.form.data.image = res.data.all_path_url;
          this.fileList.push({
            name: file.file.name,
            url: res.data.all_path_url,
          });
        });
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.form.data.desc = this.$refs.editor.editorContent;
          this.form.data.image = this.fileList
            .map((item) => item.url)
            .join(",");
          if (!this.form.data.desc) {
            this.$message.warning("描述不能为空");
            return;
          }
          let apiUrl = !this.isChange
            ? "/admin/topic/add"
            : "/admin/topic/edit";
          this.$http
            .post(apiUrl, this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
